<div
  class="mobileResultsContainer"
>

  <div class="row horizontalGuttersRemover" *ngIf="showDuelScore()">
    <div class="col div-cenered">
      <h1 *ngIf="!controlsAvailable() || (showDuelScore() && !getIsPC())">{{ getPlayerOneScore() }}</h1>
    </div>
    <div class="col div-cenered">
      <h1 *ngIf="!controlsAvailable() || (showDuelScore() && !getIsPC())">{{ getPlayerTwoScore() }}</h1>
    </div>
  </div>

  <div *ngIf="duelSeries.status == 'finished'">

    <div class="row horizontalGuttersRemover horizontalMarginsSetter">
      <div class="col div-cenered botton-main fs10w600" [class.botton-main]="getPlayerOneScore() > getPlayerTwoScore()" [class.botton-sec]="getPlayerOneScore() < getPlayerTwoScore()" *ngIf="getPlayerOneScore() != getPlayerTwoScore()">
        {{ getPlayerOneScore() > getPlayerTwoScore() ? "Победа" : "Проигрыш" }}
      </div>
      <div class="col"></div>
      <div class="col div-cenered botton-main fs10w600" [class.botton-main]="getPlayerOneScore() < getPlayerTwoScore()" [class.botton-sec]="getPlayerOneScore() > getPlayerTwoScore()" *ngIf="getPlayerOneScore() != getPlayerTwoScore()">
        {{ getPlayerOneScore() < getPlayerTwoScore() ? "Победа" : "Проигрыш" }}
      </div>
    </div>

    <div class="row horizontalGuttersRemover horizontalMarginsSetter" *ngIf="showDuelScore()">
      <div class="col div-cenered margin10">
        <img src="/static/img/arrow-down.svg" *ngIf="getPlayerOneNext()" />
      </div>
      <div class="col"></div>
      <div class="col div-cenered margin10">
        <img src="/static/img/arrow-down.svg" *ngIf="getPlayerTwoNext()" />
      </div>
    </div>

    <div class="row horizontalGuttersRemover horizontalMarginsSetter" *ngIf="showDuelScore()">
      <div class="col div-cenered">
        <a href="javascript:void(0)" class="fs12 fc-main" *ngIf="getPlayerOneNext()" (click)="goto(getPlayerOneNext())">Встреча #{{ getPlayerOneNext() }}</a>
      </div>
      <div class="col"></div>
      <div class="col div-cenered">
        <a href="javascript:void(0)" class="fs12 fc-main" *ngIf="getPlayerTwoNext()" (click)="goto(getPlayerTwoNext())">Встреча #{{ getPlayerTwoNext() }}</a>
      </div>
    </div>

  </div>

  <div
    class="tableDivMobile"
    *ngIf="duelSeries.previewDuels?.length || duelSeries.duels?.length"
  >
    <table class="table">
      <thead
        class="tHeadMobile"
      >
      <tr>
        <th
          colspan="3"
          class="align-center tHeadCellPaddingsCleanerMobile"
          scope="col"
        >
          <div
            class="tHeadDivMobile"
          >
            Результаты партий
          </div>
        </th>
      </tr>
      </thead>
      <tbody>

      <tr *ngFor="let duel of duelSeries.previewDuels && duelSeries.previewDuels.length ? duelSeries.previewDuels : duelSeries.duels">
        <td>
          <div class="d-flex justify-content-center">
            <div
              [class.cell-bordered-prim_color]="duel.player_one_score > duel.player_two_score"
              [class.cell-bordered]="duel.player_one_score <= duel.player_two_score"
            >
              {{ duel.player_one_score }}
            </div>
          </div>
        </td>
        <td>
          <div class="cell">Партия {{ duel.number }}</div>
          <div class="cell">
<!--            <a-->
<!--              href="javascript: void(0)"-->
<!--              class="text-danger"-->
<!--              (click)="deleteDuel(duel.id)"-->
<!--              *ngIf="duel.id && controlsAvailable()"-->
<!--            >-->
<!--              Удалить-->
<!--            </a>-->
          </div>
        </td>
        <td>
          <div class="d-flex justify-content-center">
            <div
              [class.cell-bordered-prim_color]="duel.player_one_score < duel.player_two_score"
              [class.cell-bordered]="duel.player_one_score >= duel.player_two_score"
            >
              {{ duel.player_two_score }}
            </div>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>

</div>
